var _mask, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiteVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5354_11452",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z",
    fill: "#9810FA",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0V1H30V0V-1H10V0ZM40 10H39V30H40H41V10H40ZM30 40V39H10V40V41H30V40ZM0 30H1V10H0H-1V30H0ZM10 40V39C5.02944 39 1 34.9706 1 30H0H-1C-1 36.0751 3.92487 41 10 41V40ZM40 30H39C39 34.9706 34.9706 39 30 39V40V41C36.0751 41 41 36.0751 41 30H40ZM30 0V1C34.9706 1 39 5.02944 39 10H40H41C41 3.92487 36.0751 -1 30 -1V0ZM10 0V-1C3.92487 -1 -1 3.92487 -1 10H0H1C1 5.02944 5.02944 1 10 1V0Z",
    fill: "#AD46FF",
    fillOpacity: 0.3,
    mask: "url(#path-1-inside-1_5354_11452)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5354_11452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1807 12.3454C19.2164 12.1542 19.3179 11.9815 19.4675 11.8573C19.6171 11.7331 19.8054 11.665 19.9999 11.665C20.1943 11.665 20.3827 11.7331 20.5323 11.8573C20.6819 11.9815 20.7833 12.1542 20.819 12.3454L21.6949 16.977C21.7571 17.3063 21.9171 17.6092 22.1541 17.8462C22.391 18.0831 22.6939 18.2432 23.0232 18.3054L27.6549 19.1812C27.846 19.2169 28.0187 19.3183 28.1429 19.4679C28.2672 19.6176 28.3352 19.8059 28.3352 20.0004C28.3352 20.1948 28.2672 20.3832 28.1429 20.5328C28.0187 20.6824 27.846 20.7838 27.6549 20.8195L23.0232 21.6954C22.6939 21.7576 22.391 21.9176 22.1541 22.1546C21.9171 22.3915 21.7571 22.6944 21.6949 23.0237L20.819 27.6554C20.7833 27.8465 20.6819 28.0192 20.5323 28.1434C20.3827 28.2677 20.1943 28.3357 19.9999 28.3357C19.8054 28.3357 19.6171 28.2677 19.4675 28.1434C19.3179 28.0192 19.2164 27.8465 19.1807 27.6554L18.3049 23.0237C18.2427 22.6944 18.0826 22.3915 17.8457 22.1546C17.6087 21.9176 17.3058 21.7576 16.9765 21.6954L12.3449 20.8195C12.1537 20.7838 11.9811 20.6824 11.8568 20.5328C11.7326 20.3832 11.6646 20.1948 11.6646 20.0004C11.6646 19.8059 11.7326 19.6176 11.8568 19.4679C11.9811 19.3183 12.1537 19.2169 12.3449 19.1812L16.9765 18.3054C17.3058 18.2432 17.6087 18.0831 17.8457 17.8462C18.0826 17.6092 18.2427 17.3063 18.3049 16.977L19.1807 12.3454Z",
    stroke: "#DAB2FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 11.667V15.0003",
    stroke: "#DAB2FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 13.333H25",
    stroke: "#DAB2FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 28.3333C14.2538 28.3333 15 27.5871 15 26.6667C15 25.7462 14.2538 25 13.3333 25C12.4129 25 11.6667 25.7462 11.6667 26.6667C11.6667 27.5871 12.4129 28.3333 13.3333 28.3333Z",
    stroke: "#DAB2FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5354_11452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiteVector);
export default __webpack_public_path__ + "static/media/lite-vector.7110114232080a79e040ac2f0c02a313.svg";
export { ForwardRef as ReactComponent };